import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-weight-bold" }

import SettingsViewModel from "@/viewmodels/app/SettingsViewModel";


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsComponent',
  setup(__props) {

const viewModel = new SettingsViewModel();

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                border: "",
                class: "pa-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        variant: "tonal",
                        size: "56",
                        color: "primary",
                        class: "mx-auto"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(viewModel).getUserInitials()), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, { class: "text-center pb-4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(viewModel).getFormattedName()), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                  _createTextVNode("ID de Socio")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(viewModel).userinfo.value?.idsocio), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (
                  _unref(viewModel).userinfo.value?.telmovil ||
                  _unref(viewModel).userinfo.value?.telfijo
                )
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                      _createTextVNode("Teléfono")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(viewModel).getHiddenPhone()), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode("Correo")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(viewModel).getHiddenEmail()), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                border: "",
                class: "pa-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Opciones")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode("mdi-power-settings")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-subtitle-1" }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("Cierre de sesión automático")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            color: "primary",
                            modelValue: _unref(viewModel).session.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(viewModel).session.value) = $event)),
                            density: "compact",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        onClick: _unref(viewModel).goToWsp
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode("mdi-headset")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-subtitle-1" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("Ayuda y Soporte")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_list_item, null, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("mdi-theme-light-dark")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-subtitle-1" }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("Modo Oscuro")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            color: "primary",
                            modelValue: _unref(viewModel).isDarkMode.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(viewModel).isDarkMode.value) = $event)),
                            density: "compact",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        onClick: _unref(viewModel).logout
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("mdi-logout")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-subtitle-1" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("Salir de la aplicación")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})